<section class="px-6 py-20 sm:px-10">
  <div class="mx-auto max-w-5xl">
    <div class="mb-8 flex items-start justify-between gap-4">
      <div>
        <span class="mb-4 block text-[0.72rem] font-semibold uppercase tracking-[0.16em] text-gold"
          >Site admin</span
        >
        <h1 class="font-display text-3xl font-semibold text-parchment">Dashboard</h1>
      </div>
      <div class="mt-1 flex shrink-0 flex-col items-end gap-1 text-sm">
        <a
          routerLink="/admin/people"
          class="text-dusk transition-colors hover:text-parchment hover:underline"
          >Manage people &rarr;</a
        >
        <a
          routerLink="/admin/competitions"
          class="text-dusk transition-colors hover:text-parchment hover:underline"
          >Manage competitions &rarr;</a
        >
        <a
          routerLink="/admin/users"
          class="text-dusk transition-colors hover:text-parchment hover:underline"
          >Manage users &rarr;</a
        >
        <a
          routerLink="/admin/plan-config"
          class="text-dusk transition-colors hover:text-parchment hover:underline"
          >Plan limits &rarr;</a
        >
      </div>
    </div>

    @if (loading()) {
      <p class="text-dusk">Loading…</p>
    } @else if (errorMessage()) {
      <p class="rounded border border-wax/40 bg-wax/10 px-4 py-3 text-sm text-parchment">
        {{ errorMessage() }}
      </p>
    } @else if (stats(); as s) {
      <div class="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div class="rounded-md border border-hairline bg-panel p-6">
          <h2 class="text-sm font-semibold uppercase tracking-wide text-dusk">Open competitions</h2>
          <p class="mt-2 text-3xl font-semibold text-gold">{{ s.openCompetitionCount }}</p>
        </div>
        <div class="rounded-md border border-hairline bg-panel p-6">
          <h2 class="text-sm font-semibold uppercase tracking-wide text-dusk">Unique contestants</h2>
          <p class="mt-2 text-3xl font-semibold text-gold">{{ s.totalContestants }}</p>
        </div>
      </div>

      <div class="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div class="rounded-md border border-hairline bg-panel p-6">
          <h2 class="text-sm font-semibold uppercase tracking-wide text-dusk">Recently added</h2>
          @if (s.recentPeople.length === 0) {
            <p class="mt-3 text-sm text-dusk">No people in the catalog yet.</p>
          } @else {
            <ul class="mt-3 flex flex-col gap-1">
              @for (person of s.recentPeople; track person.id) {
                <li>
                  <button
                    type="button"
                    (click)="openPersonId.set(person.id)"
                    class="flex w-full items-center justify-between gap-3 rounded px-1 py-1 text-left text-sm transition hover:bg-parchment/[0.04]"
                  >
                    <span class="flex items-center gap-2 text-parchment">
                      @if (person.imageUrl) {
                        <img
                          [src]="person.imageUrl"
                          alt=""
                          class="h-6 w-6 shrink-0 rounded-full object-cover"
                        />
                      }
                      {{ person.name }}
                    </span>
                    <span class="shrink-0 text-xs text-dusk">{{ person.createdAt | date: 'MMM d, y' }}</span>
                  </button>
                </li>
              }
            </ul>
          }
        </div>

        <div class="rounded-md border border-hairline bg-panel p-6">
          <h2 class="text-sm font-semibold uppercase tracking-wide text-dusk">Recently deceased</h2>
          @if (s.recentDeaths.length === 0) {
            <p class="mt-3 text-sm text-dusk">No deaths recorded yet.</p>
          } @else {
            <ul class="mt-3 flex flex-col gap-1">
              @for (person of s.recentDeaths; track person.id) {
                <li>
                  <button
                    type="button"
                    (click)="openPersonId.set(person.id)"
                    class="flex w-full items-center justify-between gap-3 rounded px-1 py-1 text-left text-sm transition hover:bg-parchment/[0.04]"
                  >
                    <span class="flex items-center gap-2 text-parchment">
                      @if (person.imageUrl) {
                        <img
                          [src]="person.imageUrl"
                          alt=""
                          class="h-6 w-6 shrink-0 rounded-full object-cover"
                        />
                      }
                      {{ person.name }}
                    </span>
                    <span class="shrink-0 text-xs text-wax-bright">{{ person.dateOfDeath | date: 'MMM d, y' }}</span>
                  </button>
                </li>
              }
            </ul>
          }
        </div>
      </div>

      <div class="rounded-md border border-hairline bg-panel p-6">
        <h2 class="text-sm font-semibold uppercase tracking-wide text-dusk">Contestants by competition</h2>
        @if (s.contestantsByCompetition.length === 0) {
          <p class="mt-3 text-sm text-dusk">No competitions yet.</p>
        } @else {
          <ul class="mt-3 flex flex-col gap-2">
            @for (c of s.contestantsByCompetition; track c.competitionId) {
              <li class="flex items-center justify-between text-sm">
                <span class="text-parchment">{{ c.name }}</span>
                <span class="tabular-nums text-dusk">{{ c.count }}</span>
              </li>
            }
          </ul>
        }
      </div>
    }

    @if (openPersonId(); as id) {
      <app-person-modal
        [personId]="id"
        (closed)="onModalClosed()"
        (changed)="onModalChanged()"
      />
    }
  </div>
</section>
